import { Enviroment } from "../../../enviroments";
import { Api } from "../axios-config"
import CookieService from "../../autenticacao/CookieService";
import { IDadosRetornoHistoricoFreeAgency } from "../freeAgency/FreeAgencyService";

export interface IDadosLeilao {
    codUsuCriacao?: number,
    franquia: IListagemTimes[],
    configuracao_Salario: IListagemSalarios[],
    lance_Leilao: IListaDadosLanceLeilao[]
}

export interface IDadosRetornoLeilaoRestrito {
    dado: IListaDadosLanceLeilao[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

type TLeilaoRestritoComTotalCount = {
    data: IDadosRetornoLeilaoRestrito;
    totalCount: number;
}


export interface IListaDadosLanceLeilao {
    codigo?: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    codigo_Free_Agency: number;
    valor: string;
    tempo_Contrato: number;
    codUsuCriacao?: number;
    foto_Jogador: string;
    nome_Jogador: string;
    rodada: number;
    valor_Ultimo_Contrato_Jogador: string;
    franquia_Direitos_Jogador: string;
    codigo_Franquia_Direitos_Jogador: number;
    logo_Franquia_Direitos_Jogador: string;
    restrito_Jogador: boolean
    posicao_Jogador_1: string;
    posicao_Jogador_2: string;
    posicao_Jogador_3: string;
    data_Fim_Lance: Date;
    data_Restante_Lance: string;
    franquia_Lance_Jogador: string;
    logo_Franquia_Lance_Jogador: number;
    valor_Desconto: string;
    aprovacao_Restrito: boolean;
}

export interface IListagemTimes {
    codigo: number;
    nome: string;
    logo: string;
    nome_Logo: string;
    cap: string;
    valor_Total_Lance: string;
    quantidade_Lance: number;
    cap_Disponivel: number;
    quantidade_Slots: number;
    quantidade_Slots_Disponivel: number;

}


export interface IListagemSalarios {
    codigo: number;
    valor_Minimo: string;
    valor_Maximo: string;
    tempo_Minimo: string;
    tempo_Maximo: string;

}

export interface IDadosRetornoLeilao {
    dado: IDadosLeilao;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}


type TLeilaoComTotalCount = {
    data: IDadosRetornoLeilao;
    totalCount: number;
}

export interface IDadosEstatisticas {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    foto?: string;
    arremessos: number;
    lance_Livre: number;
    tres_Pontos: number;
    pontos: number;
    rebotes: number;
    rebotes_Ofensivos: number;
    rebotes_Defensivos: number;
    assistencias: number;
    steal: number;
    bloqueios: number;
    turnovers: number;
    faltas: number;
    minutos: number;
    min_Plus: number;
    quantidade_Jogos: number;
    porcentagem_Arremessos: number;
    porcentagem_Lance_Livre: number;
    porcentagem_Tres_Pontos: number;
    peso_Total_Jogador: number;
    arremessos_Tentativas: number;
    lance_Livre_Tentativas: number;
    tres_Pontos_Tentativas: number;
    lance_Livre_Errados?:number;
    arremessos_Errados?:number;
    tres_Pontos_Errados?:number;
    stocks?:number;
}


export interface IDadosRetornoJogadoresEstatisticas {
    dado: IDadosEstatisticas[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDetalheJogadorLeilao {
    codigo?: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    codigo_Leilao: number;
    valor: string;
    codUsuCriacao?: number;

}

export interface IDadosContratacaoLeilao {
    codigo: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    codigo_Leilao: number;
    codUsuCriacao: number;
}

export interface IListagemHistoricoLance {
    codigo: number;
    jogador: string;
    time: string;
    valor: string;
    periodo: string;
}

export interface IDadosRetornoHistoricoLeilao {
    dado: IListaDadosHistoricoLeilao[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosHistoricoLeilao {
    codigo?: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    codigo_Leilao: number;
    valor: string;
    vencedor: boolean;
    irregular: boolean;
    codigo_Franquia_Superada?: number;
    rodada: number;
    superada: boolean;
    dtCriacao: Date;
    codUsuCriacao: number;
    nome_Jogador: string;
    foto_Jogador: string;
    nome_Franquia: string;
    logo_Franquia: string;
    data_Fim_Lance: Date;
    posicao_Jogador: string;

}

interface RespostaCreate {
    statusHTTP: number;
    status: number;
    processado: boolean;
    erros: string;
    mensagem: string;
    dado: number;
}


export interface IDadosRetornoTodosLeilao {
    dado: IListaDadosTodosLeilao[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosTodosLeilao {
    codigo?: number;
    nome: string;
    foto: string;
    posicao: string;
    rodada: number;
    lance: ILances[];
}

export interface ILances {
    codigo_Franquia: number;
    logo_Franquia: string;
    nome_Franquia: string;
    data: Date;
    valor: string;
    vencedor: boolean;
    irregular: boolean;
}



const getAllPorCodigo = async (codigoLeilao: number): Promise<TLeilaoComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/leilao/completo/${codigoLeilao}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getAllRestritoPorCodigo = async (codigoLeilao: number, codigoFranquia: number): Promise<TLeilaoRestritoComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/leilao/lance/restrito/${codigoLeilao}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getHistoricoLeilaoPorLiga = async (codigoLiga: number): Promise<IDadosRetornoHistoricoLeilao> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/leilao/historico/liga/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getHistoricoLeilao = async (codigoLeilao: number, codigoFranquia: number, rodada: number): Promise<IDadosRetornoHistoricoLeilao> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/leilao/historico/${codigoLeilao}/${codigoFranquia}/${rodada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getMeusLeiloes = async (codigoLeilao: number, codigoFranquia: number, rodada: number): Promise<IDadosRetornoHistoricoLeilao> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoHistoricoLeilao>(`/leilao/ativo/${codigoLeilao}/${codigoFranquia}/${rodada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getTodosPorCodigoLeilao = async (codigoLeilao: number): Promise<IDadosRetornoTodosLeilao> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoTodosLeilao>(`/leilao/todos/${codigoLeilao}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}



const createContratarLeilao = async (dados: IDadosContratacaoLeilao): Promise<IDadosContratacaoLeilao> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/leilao/restrito/lance`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const createJogadorLeilao = async (dados: Omit<IDetalheJogadorLeilao, "codigo">): Promise<number> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    dados.codUsuCriacao = user.codUsuario;

    const { data } = await Api.post<RespostaCreate>(`/leilao/lance`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    if (data.processado) {
        return data.dado;
    }
    return 0;
}

const updateRecusarContratoLeilao = async (dados: IDadosContratacaoLeilao): Promise<IDadosContratacaoLeilao> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.put(`/leilao/restrito/recusarlance`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

export const LeilaoService = {
    getAllPorCodigo,
    getAllRestritoPorCodigo,
    createContratarLeilao,
    updateRecusarContratoLeilao,
    getHistoricoLeilao,
    getHistoricoLeilaoPorLiga,
    createJogadorLeilao,
    getMeusLeiloes,
    getTodosPorCodigoLeilao
}